import { createSelector } from "reselect";

export const selectWholeStateChbaCheckList = (state) => state.chbaChecklist || {};

export const selectChbaCheckList = createSelector([selectWholeStateChbaCheckList], (chbaChecklist) => chbaChecklist);